import React from 'react';
import PropTypes from 'prop-types'
import classNames from 'classnames';

function Modal({ children, classes = '', overlay = true, excludeHeaderOverlay = false }) {
  return (
    <div>
      {overlay ? (
        <div className={classNames('scrollMask', { scrollMaskNoHeader: !excludeHeaderOverlay })}/>)
      : null}
      <div className={classNames('openModal', classes)}>
        <div>{children}</div>
      </div>
    </div>
  );
}

Modal.propTypes = {
  classes: PropTypes.string,
  overlay: PropTypes.bool,
  excludeHeaderOverlay: PropTypes.bool,
};

export default Modal;
